<template>
  <UiEmpty v-if="!giftingEnabled"></UiEmpty>
  <div v-else class="personal">
    <div class="persona-left">
      <div class="persona-banner" @click="handleClickshowPersona"></div>
      <ul class="top-three">
        <li class="top-tow" :class="RANK_IDS[i]" v-for="(v, i) in topThree" :key="i">
          <div class="picture" :style="{
            'background-image': `url(${v?.avatarUrl ? v?.avatarUrl : defaultUrl})`
          }">
          </div>
          <div class="name">
            <div class="label-box">
              <div class="label-shadow">{{ v?.nickName ? v?.nickName : '-' }}</div>
              <div class="label-text">{{ v?.nickName ? v?.nickName : '-' }}</div>
            </div>
          </div>
          <div class="dedicate">
            <div class="ded">
              <div class="label-box">
                <div class="label-shadow">贡献值 {{ countShow(v?.popularity) }}</div>
                <div class="label-text">贡献值 {{ countShow(v?.popularity) }}</div>
              </div>
            </div>
          </div>
          <div class="icon"></div>
        </li>
      </ul>

      <!-- 4-6 -->
      <ul class="bottom-three">
        <li class="three-item" v-for="(item, k) in fourToSix" :key="k">
          <div class="title1">
            <div class="label-box">
              <div class="label-shadow">{{ k + 4 }}</div>
              <div class="label-text">{{ k + 4 }}</div>
            </div>
          </div>
          <div class="user">
            <div class="avatar" :style="{
              'background-image': `url(${item?.avatarUrl ? item?.avatarUrl : defaultUrl})`
            }">
            </div>
            <div class="name">{{ item?.nickName || '-' }}</div>
          </div>
          <div class="hot">
            贡献值 {{ countShow(item?.popularity) }}
          </div>
        </li>
      </ul>
    </div>
    <div class="persona-right">
      <FanList
        :items="sevenAndBeyond"
        :default-avatar="defaultUrl"
        :start-index="7"
        :user-info="personaList?.personal"
        :user-img-url="personaList?.personal?.avatarUrl"
        bg-type="solid"
      />
    </div>

  </div>
</template>

<script setup>
// 页签名 personal(与 UI/URL 一致), 实际数据维度: 个人送礼贡献值累积排行
import { computed, ref } from 'vue'
import { useAppStore, useStageStore } from '@/store'
import UiEmpty from '@/components/ui-empty'
import FanList from '@/views/ranking/fan-list.vue'

const appStore = useAppStore()
const stageStore = useStageStore()
const giftingEnabled = computed(() => stageStore.giftingEnabled)

const props = defineProps({
  personaList: Object
})

function countShow(hot) {
  if (hot) {
    if (hot < 10000) return hot
    if (hot < 99999999) return (((hot / 10000) * 100) / 100).toFixed(2) + '万'
    return 9999 + '万+'
  }
  return 0
}


const defaultUrl = ref('https://website.xdcdn.net/form/match/avatar2024/Portrait1.png')

// topThree 排列后的位置 → rank-N class (icon 切图和 rank 特有样式在 index.scss 里通过 rank-N 层控制)
const RANK_IDS = ['rank-2', 'rank-1', 'rank-3']

// 筛选第 1-3 名的数据

const topThree = computed(() => {
  let topItems = props.personaList.totalList.filter((item, index) => index >= 0 && index <= 2);
  // console.log('topItems',topItems)
  // 如果只有一个元素，返回 "0, 1, 0" 的排列方式

  if (topItems.length === 0) {
    return [null, null, null];
  } else if (topItems.length === 1) {
    return [null, topItems[0], null];
  } else if (topItems.length === 2) {
    return [topItems[1], topItems[0], null];
  } else {
    return [topItems[1], topItems[0], topItems[2]];
  }
})

// 筛选第 4-6 名的数据
const fourToSix = computed(() => {
  let center = props.personaList.totalList.filter((item, index) => index >= 3 && index <= 5);

  let result = [null, null, null];
  // 将 `center` 的内容填充到 `result` 中
  center.forEach((item, index) => {
    result[index] = item;
  });
  return result;
})

// 筛选第 7 名及之后的数据
const sevenAndBeyond = computed(() => {
  return props.personaList.totalList?.filter((item, index) => index >= 6);
})

function handleClickshowPersona() {
  appStore.openModal({ id: 'personal-rewards' })
}
</script>

<style lang="scss" scoped>
@import "./index";
</style>
